import { useEffect, useState } from "react";

import { useDealActions, useInvestorsSelector } from "store";
import type { IAssetClass } from "store/types";

export function useFilterOptions() {
  const investors = useInvestorsSelector();
  const { getAssetClassesAction } = useDealActions();
  const [assetClasses, setAssetClasses] = useState<IAssetClass[]>([]);

  useEffect(() => {
    getAssetClassesAction().then(setAssetClasses);
  }, [getAssetClassesAction]);

  const investorOptions = investors.map((inv) => inv.name);
  const assetClassOptions = assetClasses.map((ac) => ac.name);

  return {
    investorOptions,
    assetClassOptions
  };
}